import GetRandom from "../utils/array/GetRandom";
import {
  getParams,
  redirect,
  updateUserSession
} from "../../../_common/_functions";

const invitations = {};
let anims = ["tada", "bounceIn", "fadeIn"];
let GAMES = {
  "minti-memo-multi": "Multi-Memo Multi",
  "minti-gewinnt": "Minti-Gewinnt",
  "puzzle-spiel-multi": "Puzzle-Spiel Multi"
};
let notConnect = ["/choice"];

function setWeiter() {
  $("#nextButton")
    .removeClass("d-none")
    .attr("href", App.weiter);
}
function updateCredit(credit) {
  /*Swal.fire({
      type: 'success',
      title: 'Gratulation!',
      html: `<h2>Du hast <strong>${ credit.format() }</strong> Mintos bekommen.</h2>`,
      animation: false,
      customClass: {
          popup: 'animated tada'
      }
  });*/
  try {
    App.user.addCredit(credit);
    if (App.type === "kids") {
      return console.warn("Kids Lobibox Alert!!");
    }

    Lobibox.alert("success", {
      title: "Gratulation!",
      msg: `<h2>Du hast <strong>${credit.format()}</strong> Mintos bekommen.</h2>`,
      animation: false,
      customClass: {
        popup: "animated tada"
      }
    });
  } catch (e) {}
}
function SwalNotify(data, anim) {
  if (!anim) {
    anim = GetRandom(anims);
  }
  Swal.fire({
    position: "center",
    title: data,
    showConfirmButton: false,
    timer: 1500,
    animation: false,
    customClass: {
      popup: "animated " + anim
    }
  });
  /*Lobibox.notify('success', {
      title: data, time: 1500,
      size: 'mini', rounded: true
  });*/
}
function hideText(txt) {
  let splitTxt = txt.split(" ");
  let hideTxt = "";

  splitTxt.forEach(f => {
    for (let i = 0; i < f.length; i++) {
      if (i === 0 || i === 1) {
        hideTxt += f[i];
      } else {
        hideTxt += "*";
      }
    }
    hideTxt += " ";
  });

  return hideTxt;
}
function LobiboxNotifications(array, sendAxios = false) {
  if (!Array.isArray(array)) {
    array = [array];
  }
  for (let i = 0; i < array.length; i++) {
    const prm = array[i];
    switch (prm.type) {
      case "App\\Notifications\\Mintosvergabe":
        Lobibox.notify("info", {
          showClass: "fadeInDown",
          hideClass: "fadeUpDown",
          sound: false,
          size: "large",
          title: "<strong>Mintos</strong> bekommen.",
          img: "/images/happy-minti.png",
          msg:
            "<h4>Du hast von <strong>" +
            prm.username +
            " " +
            prm.mintos +
            "  Mintos</strong> bekommen.</h4>"
        });
        if (sendAxios) {
          App.user.addCredit(parseInt(prm.mintos.replaceAll(".", "")));
        }
        break;
      case "App\\Notifications\\Like":
        Lobibox.notify("success", {
          showClass: "fadeInDown",
          hideClass: "fadeUpDown",
          sound: false,
          size: "large",
          title: "<strong>Meine Mitschüler</strong>",
          img: "/images/like-minti.png",
          msg:
            "<h3><strong>" + prm.username + "</strong> hat dich geliked!</h3>"
        });
        break;
      case "App\\Notifications\\Mintiguru":
        Lobibox.notify("warning", {
          showClass: "fadeInDown",
          hideClass: "fadeUpDown",
          sound: false,
          size: "large",
          title: "<strong>MintiGuru</strong>",
          img: "/spiel-spass/mintiguru/guru.png",
          msg: `<div>Du hast <span class='text-bold'>${prm.mintos}</span> Mintos gewonnen.</div><p>Liebe Grüße</p>`
        });
        if (sendAxios) {
          App.user.addCredit(parseInt(prm.mintos.replaceAll(".", "")));
        }
        break;
      case "App\\Notifications\\Credit":
        Lobibox.notify("warning", {
          showClass: "fadeInDown",
          hideClass: "fadeUpDown",
          sound: false,
          size: "large",
          title: "<strong>" + prm.title + "</strong>",
          img: "/images/happy-minti.png",
          msg: `${prm.message}`
        });
        if (sendAxios) {
          App.user.addCredit(parseInt(prm.mintos));
        }
        break;
    }
  }
  if (array.length && sendAxios) {
    fetchPost(`${App.url}/${App.type}/read-notifications`);
  }
}

window.GetRandom = GetRandom;
window.setWeiter = setWeiter;
window.SwalNotify = SwalNotify;
window.updateCredit = updateCredit;
window.LobiboxNotifications = LobiboxNotifications;

let prms = getParams();
if (prms.port) {
  App.port = prms.port;
  console.log("port değişti:::" + App.port);
}
if (!notConnect.includes(window.location.pathname)) {
  const socket = io.connect(App.socket_url + ":" + App.port, {
    withCredentials: true
  });
  window.socket = socket;
  const __once = socket.__proto__.once,
    __on = socket.__proto__.on;

  function on(event, fn) {
    if (event.includes("Game__") && socket.hasListeners(event)) {
      return console.warn("Nope!");
    }
    __on.apply(socket, arguments);
  }
  socket.__proto__.on = socket.__proto__.addEventsListener = on;
  socket.__proto__.once = function(event, fn) {
    if (event.includes("Game__") && socket.hasListeners(event)) {
      return console.warn("Nope!");
    }
    __once.apply(socket, arguments);
  };

  window.socketSetData = function socketSetData(url) {
    socket.emit("modul_set_timer", url);
  };

  socket.on("redirect", redirect);
  socket.on("notify", SwalNotify);
  socket.on("updateCredit", updateCredit);
  socket.on("notifyUserInvitation", (roomID, key, username) => {
    socket.emit("invitationReceived", roomID);
    if (typeof App.autoSearch === "undefined") {
      /*invitations[roomID] = Lobibox.confirm({
          type: 'warning',
          title: 'Anfrage',
          msg: `<strong>${username}</strong> möchte mit dir <strong>${GAMES[key]}</strong> spielen. Was denkst du?`,
          confirmButtonText: 'Ok!',
          cancelButtonText: 'Keine Lust!',
          callback: ($this, type, ev) => {
              socket.emit('invitationAnswer', roomID, type !== 'no');
          }
      })*/
      invitations[roomID] = Swal.fire({
        title: "Anfrage",
        html: `<strong>${hideText(username)}</strong> möchte mit dir <strong>${
          GAMES[key]
        }</strong> spielen. Was denkst du?`,
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#dd3333",
        confirmButtonText: "Ok!",
        cancelButtonText: "Keine Lust!",
        animation: false,
        customClass: {
          popup: "animated " + GetRandom(anims)
        }
      });
      invitations[roomID].then(result => {
        socket.emit("invitationAnswer", roomID, result.value || false);
      });
    } else {
      socket.emit("invitationAnswer", roomID, key === App.autoSearch.gameType);
    }
  });
  socket.on("cancelUserInvitation", roomID => {
    if (invitations[roomID]) {
      try {
        invitations[roomID].close({ value: false });
      } catch (e) {
        try {
          invitations[roomID].destroy();
        } catch (e) {}
      }
    }
  });
  socket.on("invitationCanceled", msg => {
    if (msg) {
      Lobibox.notify("error", {
        msg,
        size: "mini",
        rounded: true,
        showClass: "fadeInDown",
        hideClass: "fadeUpDown"
      });
    }
  });
  socket.on("confirm", (data, type = "Lobibox") => {
    if (type === "Swal") {
      Swal.fire(
        Object.assign(
          {
            type: "warning",
            animation: false,
            customClass: {
              popup: "animated " + GetRandom(anims)
            },
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#dd3333",
            confirmButtonText: "Ja.",
            cancelButtonText: "Nein!",
            showCancelButton: true,
            showConfirmButton: true,
            allowOutsideClick: false,
            allowEnterKey: true,
            allowEscapeKey: true
          },
          data
        )
      ).then(result => {
        socket.emit("confirmAnswer", result.value);
      });
    } else if (type === "Lobibox") {
      data.msg = data.title;
      data.title = "Info";
      Lobibox.confirm(
        Object.assign(
          {
            showClass: GetRandom(anims),
            title: "Info",
            closeButton: false,
            closeOnEsc: false,
            buttons: {
              yes: {
                class: "btn btn-success px-5",
                text: "Ja",
                closeOnClick: true
              },
              no: {
                class: "btn btn-danger px-5",
                text: "Nein",
                closeOnClick: true
              }
            },
            iconClass: "fa fa-info-circle",
            callback: function($this, type, ev) {
              socket.emit("confirmAnswer", type !== "no");
            }
          },
          data
        )
      );
    }
  });
  socket.on("remove_not_point_save", link => {
    axios.post("/api/removelink", { link });
    setWeiter();
  });
  socket.on("modul_interval", time => {
    let $content = $(".pagination-new");
    let timer = $content.find("#timer");
    if (timer.length === 0) {
      $content.prepend('<div id="timer">Weiter in <span></span> Sek.</div>');
      timer = $content.find("#timer");
    }
    timer.find("span").text(time);
  });
  socket.on("modul_interval_completed", () => {
    $("#timer").remove();
    $("#nextButton")
      .removeClass("d-none")
      .on("click", () => {
        socketSetData(App.weiter);
      });
  });
  socket.on("showNext", setWeiter);
  socket.on("lobiboxNotifications", LobiboxNotifications);
  socket.on("setMultiplayer", isEnabled => {
    events.$emit("setMultiplayer", isEnabled);
  });

  socket.on("updateSessionLastActivity", updateUserSession);

  socket.on("under-construction", () => {
    Swal.fire({
      title: "",
      html: '<img class="img-fluid" src="/images/bakim-calismasi.jpg">',
      showCloseButton: false,
      animation: false,
      customClass: {
        popup: "animated tada col-8"
      },
      showCancelButton: false,
      focusConfirm: false,
      confirmButtonText: '<i class="fa fa-thumbs-up"></i> Ok!',
      confirmButtonAriaLabel: "Thumbs up, great!"
    });
  });
}
